// extracted by mini-css-extract-plugin
export var menuIcon = "_pw-0";
export var menuIconInline = "_pw-1";